import erpApiInstance from '@/axios/interceptor/erp/interceptor';

// 获取公司列表篇
function hasYcService(type) {
  return erpApiInstance.get(`/web/redirect/info?productType=${type}`);
}

export default {
  hasYcService
}